import UIIcon from 'UIComponents/icon/UIIcon';
import UIButton from 'UIComponents/button/UIButton';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { CALYPSO } from 'HubStyleTokens/colors';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const DataPassingPanelHeaderEditAvailableButton = ({
  openFetchObjectPanel
}) => {
  return /*#__PURE__*/_jsx(TFlex, {
    justify: "between",
    role: 'addDataSourceBtn',
    "data-panel-blur-ignore": "true",
    children: /*#__PURE__*/_jsxs(UIButton, {
      use: "link",
      onClick: openFetchObjectPanel,
      "data-test-id": "data-panel-edit-available-data-sources-btn",
      children: [/*#__PURE__*/_jsx(UIIcon, {
        name: "edit",
        color: CALYPSO
      }), /*#__PURE__*/_jsx(FormattedMessage, {
        message: "automation-ui-formula-editor.data-passing-panel.search-properties-top-panel.edit-data-btn-text"
      })]
    })
  });
};
export default DataPassingPanelHeaderEditAvailableButton;